export function createNpcMethods(api) {
    return {
        async listNpcs(campaignId) {
            const {data} = await api.gamemasterCampaignsNpcsRetrieve(campaignId);
            return data;
        },

        /**
         * @param {string} campaignId
         * @param {{name: string, description?: string}} npc
         */
        async createNpc(campaignId, npc) {
            const {data} = await api.gamemasterCampaignsNpcsCreate(campaignId, npc);
            return data;
        },

        async updateNpc(campaignId, npcId, changes) {
            const {data} = await api.gamemasterCampaignsNpcsPartialUpdate(campaignId, npcId, changes);
            return data;
        },

        async removeNpc(campaignId, npcId) {
            await api.gamemasterCampaignsNpcsDestroy(campaignId, npcId);
        },

        /**
         * @param {string} campaignId
         * @param {string} npcId
         * @param {{position_id: string, dimension_id?: number|null}} placement
         */
        async placeNpc(campaignId, npcId, placement) {
            const {data} = await api.gamemasterCampaignsNpcsPlaceCreate(campaignId, npcId, placement);
            return data;
        },
    };
}
